import { createContext } from 'react';
import { encode, decode } from 'base-64';
import { EncryptStorage } from 'encrypt-storage';
import { updateSiblings } from './service/RecruiterApi';

const REACT_APP_SECRET_NAME = error2('dedjhvklrgdjldfflsdbfajnlksvdbsfalksdbsglvkfbdvnsalsdlnsvassvjanhdu');
export const encryptStorage = new EncryptStorage(REACT_APP_SECRET_NAME, {
    stateManagementUse: true,
    storageType: 'localStorage',
});

export const workDayURL = `https://hive.avasoft.com/todo/index.html`;

export const PerformanceURL = `https://n4egksvmqd.execute-api.ap-south-1.amazonaws.com/AVA-HIVE-PROD-API/performance`;
export const Directory_URL = 'https://n4egksvmqd.execute-api.ap-south-1.amazonaws.com/AVA-HIVE-PROD-API/employee-directory';
export const Leave_URL = 'https://n4egksvmqd.execute-api.ap-south-1.amazonaws.com/AVA-HIVE-PROD-API/leave';
export const ADMIN_NODE_URL = 'https://n4egksvmqd.execute-api.ap-south-1.amazonaws.com/AVA-HIVE-PROD-API/admin';
export const DASHBOARD_URL = 'https://n4egksvmqd.execute-api.ap-south-1.amazonaws.com/AVA-HIVE-PROD-API/dashboard';
export const Todo_URL = 'https://n4egksvmqd.execute-api.ap-south-1.amazonaws.com/AVA-HIVE-PROD-API/concern';
export const NODE_URL = 'https://n4egksvmqd.execute-api.ap-south-1.amazonaws.com/AVA-HIVE-PROD-API/recruitment';
export const CNode_url = 'https://n4egksvmqd.execute-api.ap-south-1.amazonaws.com/AVA-HIVE-PROD-API/candidateflow';
export const centcomURL = 'https://n4egksvmqd.execute-api.ap-south-1.amazonaws.com/AVA-HIVE-PROD-API/getFields';

export const UserContext = createContext();

export const employeeDirectoryConstant = {
    module: {
        TeamDirectory: 1,
        Feedback: 2,
        Centcom: 7,
    },
    methodname: {
        getEmployeeDetails: 1,
        getProfileAndCoverImage: 2,
        getEmployeeAddress: 3,
        getEmployeeBankInfo: 4,
        getEmployeeEducationInfo: 5,
        getEmployeeCertificateInfo: 6,
        getEmployeePassportInfo: 7,
        getEmployeePreviousEmploymentInfo: 8,
        getEmployeeSkillInfo: 9,
        getEmployeeDependentInfo: 10,
        getEmployeePrimaryInfo: 11,
        getEmployeeSalaryRevisionInfo: 12,
        deleteSkillInfo: 13,
        getEmployeeSalaryRevisionInfoForm: 14,
        postEmployeePrimaryInfo: 15,
        postEmployeeAddress: 16,
        postEmployeeBankInfo: 17,
        postEmployeeEducationInfo: 18,
        postEmployeeCertificateInfo: 19,
        PostEmployeePassportInfo: 20,
        postEmployeePreviousEmploymentInfo: 21,
        postEmployeeSkillInfo: 22,
        postEmployeeSalaryRevisionInfo: 23,
        getMaritalStatus: 24,
        getCountry: 25,
        getState: 26,
        getBankName: 27,
        getAccountType: 28,
        getRelationship: 29,
        getPlaceOfissue: 30,
        getNationality: 31,
        getEducationQualification: 33,
        getInsuranceType: 32,
        getFieldOfStudy: 34,
        postEmployeeDependentInfo: 35,
        getEmployeeDocumentInfo: 36,
        getPremilinaryOnboard: 38,
        getOnboardSummary: 39,
        getEmployeeAddressForGrid: 44,
        getEmployeeBankInfoForGrid: 45,
        getEmployeeEducationInfoForGrid: 46,
        getEmployeeCertificateInfoForGrid: 47,
        getEmployeePassportInfoForGrid: 48,
        getEmployeePreviousEmploymentInfoForGrid: 49,
        getHrList: 50,
        getDomain: 51,
        getEmployeeDependentInfoForForm: 52,
        getCurrentEvaluationPeriod: 53,
        PostEmployeeVisaInfo: 54,
        getEmployeeVisaInfo: 55,
        getEmployeeVisaInfoForGrid: 56,
        getCTC: 57,
        getStatus: 58,
        getGroup: 59,
        postEmployeeDocumentInfo: 60,
        postCoverImage: 61,
        getEmploymentType: 62,
        getEmployeeDetailsForDashboard: 63,
        getCurrentCTC: 64,
        getNotificationId: 65,
        getEmpReportsToAndRole: 66,
        getReportingEmpId: 67,
        getPolicyData: 68,
        getEmployeeFeedbacks: 1,
        postFeedback: 2,
        postFeedbackResponse: 3,
        postHrApproval: 4,
        getIndivigualEmpFeedback: 6,
        getFeedbackAudit: 7,
        postHrDeny: 5,
        getFeedbackDataSpecificFlag: 8,
        getFlagCountAndName: 9,
        getFeedbackHeaderDetails: 10,
        getEmployeeData:2,
        editTodo:3,
        getDomainSkillAndProjects:1,
        getS3url:12 
    },
};

// const removeRandomCharacters = (str) => {
//     var result = '';
//     for (var i = 0; i < str.length; i++) {
//         result += str.charAt(i);
//         if (i < str.length - 1) {
//             i++; // Skip the random character
//         }
//     }
//     return result;
//   }
 
//  const modifiedString = error('');
 
 // Decoding the encoded string
//  const decodedStringaccessKey = decode(modifiedString);
 
 function error(str) {
    return str.slice(3, -3);
}
// const modifiedString1 = error('')
// const decodedStringaccessKeyID = decode(modifiedString1);
// export const bucketConfig = {
//     bucketName: process.env.REACT_APP_BUCKET_NAME,
//     region: process.env.REACT_APP_REGION,                                                                      //process.env.REACT_APP_REGION,
//     accessKeyId:decodedStringaccessKey ,                                          //removeRandomCharacters(decode(process.env.REACT_APP_ACCESS_KEY_ID)),
//     secretAccessKey:   decodedStringaccessKeyID                               //removeRandomCharacters(decode(process.env.REACT_APP_SECRET_ACCESS_KEY)),
// };
export const PerformanceConstant = {
    modulename: {
        performance: 1,
    },
    methodname: {
        goalTemplate: 19,
        deleteTemplate: 31,
        updateTemplate: 21,
        postTemplate: 20,

        appreciation: 8,
        individualAppreciation: 26,
        updateAppreciation: 10,
        postAppreciation: 9,
        deleteAppreciation: 15,

        profileRequest: 16,
        individualProfileRequest: 17,
        updateRequest: 18,

        policy: 11,
        individualPolicy: 27,
        updatePolicy: 12,
        postPolicy: 13,
        deletePolicy: 14,
        totalHighlight: 34,

        postTouchbase: 1,
        individualTouchbase: 3,
        updateTouchbase: 6,
        touchbase: 2,
        directory: 35,
        checkFeedback: 36,
        postTouchbaseFeedBack: 4,
        updateTouchbaseFeedBack: 7,
        deleteTouchbase: 5,

        myGoal: 24,
        postGoal: 22,
        updateGoal: 23,
        individualGoal: 25,
        Evaluation: 37,
        TeamGoal: 38,
        goalView: 39,
        getToImprove: 40,
        postEvaluation: 28,
        updateEvaluation: 29,
        IndividualEvaluation: 30,
        EvaluationStatus: 41,
        deleteGoal: 32,
        goalLimit: 42,
        checkRoleEvaluation: 43,
        getIndividualLog: 44,
        approveAllRequests: 45,
    },
};
export const WfhConstant = {
    modulename: {
        WfhRoute: 1,
        leave: 2,
    },
    methodname: {
        postwfhDetails: 2,
        individualwfh: 3,
        updateWfh: 4,
        getWfh: 1,
        getwfhstatus: 6,
        wfhFilter: 5,
        getLeaveInED: 7,

        getLeave: 1,
        getLeaveStatusDD: 2,
        getDomainDD: 3,
        getLeaveTypeDD: 4,
        leaveTemplate: 5,
        remainingLeave: 7,
        reviewRequest: 9,
        postLeave: 8,
        updateLeave: 10,
        leaveCount: 6,
        notificationInsert: 12,
        getNotification: 11,
        updateNotification: 15,
        getStateAndRoute: 16,
        getWorkdaysCount: 17,

        updateLeave2: 13,
        remainingLeave2: 14,
        leaveCount2: 1818,
        selectClickedNotification: 20,
    },
};

export const apiIndex = {
    modulename: {
        OffboardingRoute: 3,
    },
    methodname: {
        getoffboardingGrid: 1,
        postinitiateOffboardingData: 2,
        postinitialTransitionOffboardingData: 3,
        postdeleteOffboardingData: 4,
        postsaveOffboardingData: 5,
        updateTransitionPlan: 6,
        postapplyFilterOffboarding: 7,
        getReasonForRelieving: 8,
        getAssignTemplate: 9,
        getAllOffboardingTemplateTasks: 10,
        offboardingGriduser: 11,
        getOffboardingDetailsById: 12,
        postIndividualTask: 13,
        getdirectoryHR: 14,
        gettotalCount: 16,
        postIndividualTaskStatus: 15,
        manipulateIndividualOffboardTask: 18,
        getOffboardingTemplateTask2: 19,
        getResponsiblePersonId: 20,
        updateTemplatePlan: 21,
    },
};

export const adminApiIndex = {
    modulename: {
        holiday: 1,
        leaveData: 2,
        announcement: 3,
        evaluvation: 4,
        teammood: 5,
        offboarding: 6,
        department: 7,
        recruitment: 8,
        groups: 9,
        login: 10,
    },
    methodname: {
        getLeaveData: 1,
        postLeaveData: 2,
        updateLeaveData: 3,
        deleteLeaveData: 4,
        getAnnouncement: 1,
        postAnnouncement: 2,
        updateAnnouncement: 3,
        deleteAnnouncement: 4,
        getEvaluation: 3,
        postEvaluation: 2,
        updateEvaluation: 4,
        deleteEvaluation: 5,
        updateEvaluationGoal: 6,
        getTeamMood: 1,
        postTeamMood: 2,
        updateTeamMood: 3,
        getTeamMoodCategory: 4,
        postTeamMoodCategory: 5,
        updateTeamMoodCategory: 6,
        deleteTeamMoodCategory: 7,
        getHoliday: 8,
        postHoliday: 7,
        updateHoliday: 9,
        deleteHoliday: 10,
        getHolidayIcon: 12,
        getOffboardingTemplate: 1,
        postOffboardingTemplate: 2,
        updateOffboardingTemplate: 3,
        deleteOffboardingTemplate: 4,
        getOffboardingTemplateTask: 9,
        postOffboardingTemplateTask: 10,
        updateOffboardingTemplateTask: 11,
        deleteOffboardingTemplateTask: 12,
        getRecruitmentMessage: 1,
        postRecruitmentMessage: 2,
        updateRecruitmentMessage: 3,
        deleteRecruitmentMessage: 4,
        getAllDesigination: 9,
        postDesigination: 10,
        updateDesigination: 11,
        deleteDesigination: 12,
        getFresherQuestion: 17,
        postFresherQuestion: 18,
        updateFresherQuestion: 19,
        deleteFresherQuestion: 20,
        getDepartmentData: 1,
        getAllGroup: 3,
        postGroup: 4,
        updateGroup: 5,
        deleteGroup: 6,
        getWeekend: 5,
        postWeekend: 4,
        updateWeekend: 6,
        getOfferletter: 5,
        postOfferletter: 6,
        GetRoleName: 2,
        updateOfferletter: 7,
        deleteOfferletter: 8,
        getOffboardingTemplateTask2: 19,

        getSecAudits: 5,
        getGRC: 6,
    },
};

const value = error('hyt716f83c3-7abd-42a1-86d2-e0207f4aa981kwr');

const value2 = error('kycd9aa0b7c-c26e-49e9-8c9e-dcbd94a17947gdc');

// const value= error('retcd5dbd24-330a-4174-8e00-dc550f63976bbtf');

// const value2=error('atreb9d4fda-7155-44b4-a2e7-28a042b8f329bnh');

export const loginCredientials = {
    tenantId: value,
    clientId: value2,
};

export const weekDays = {
    0: 'Sunday',
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday',
};
export const dashboardApiIndex = {
    modulename: {
        dashboard: 1,
    },
    methodname: {
        countData: 10,
        announcementData: 13,
        spotlightData: 16,
        concernData: 12,
        myToDo: 11,
        myTeam: 14,
        appreciationData: 19,
        policyData: 20,
        faqData: 21,
        empTeamData: 22,
        empGoalData: 23,
        formPopUp: 25,
        performanceData: 1,
        leaveData: 2,
        feedbackData: 3,
        teamCountData: 5,
        ratingData: 7,
        salaryData: 6,
        moodData: 4,
        attritionData: 15,
        moodGridData: 8,
        domainData: 26,
        evalData: 27,
        moodReasonsData: 28,
        moodAnalyticData: 9,
        reasonData: 29,
        postMood: 18,
        empLeave: 24,
        previousEvaluation: 30,
        empLeave2: 31,
        setEvaluationPeriod: 32,
        generateBulkOffer: 34,
        //adding method name for attrition dashboard
        getInsiteByDomain: 35,
        getExitByGender: 38,
        getAttritionByTenure: 37,
        getAttritionByReason: 39,
        ReasonType: 40,
        designation: 41,
    },
};

const recruitmentAPIIndex = {
    modulename: {
        CandidateGrid: 1,
        InterviewRound: 2,
        Offer: 3,
        Timeline: 4,
        OfferDetails: 5,
        Feedback: 6,
        Onboarding: 7,
        Jobs: 8,
        Task: 9,
        Documents: 10,
        performance: 1,
        JobsLanding: 12,
    },
    methodname: {
        updateSiblings:19,
        sendMail:6,
        getSalaryDetails: 7,
        getCollegeDetail: 18,
        // getFresherCandidate: 1,
        // getExpCandidate: 2,
        getJobCandidate: 1,
        postHoldCandidate: 3,
        updateHoldCandidate: 4,
        getReportingDetails: 8,
        postReportingDetails: 9,
        updateReportingDetails: 10,
        postExpHoldCandidate: 5,
        updateExpHoldCandidate: 6,
        updateFresherStatus: 7,
        updateExpStatus: 8,
        getCandidateProfile: 9,
        getAllCandidates: 10,
        getCandidateJobDetails: 11,
        postFresherInterchange: 12,
        postExpInterchange: 13,
        getCandidateFilterData: 14,
        getCandidateSearchData: 15,

        getInterviewRound: 1,
        postInterview: 2,
        postBulkInterview: 10,
        postExpBulkInterview: 11,
        updateInterview: 3,
        postExpInterview: 4,
        updateExpInterview: 5,
        getScheduledInterview: 6,
        getInterviewers: 7,
        deleteScheduledInterview: 8,
        getEditScheduledInterview: 9,

        getOfferLetterDetails: 1,
        getExpOfferLetterDetails: 2,

        getTimeline: 1,
        getExpTimeline: 2,
        postTimeline: 3,
        removeHiringTeam: 21,

        postSalaryDetails: 1,
        updateSalaryDetails: 2,
        postExpSalaryDetails: 3,
        updateExpSalaryDetails: 4,
        getCandidateOfferDetails: 5,

        postFeedback: 1,
        postAssesmentFeedback: 2,
        getFeedback: 3,
        updateFeedback: 4,
        updateAssFeedback: 5,
        getOverallRecommendation: 6,
        postoverallRecommendation: 7,
        sendFeedback: 8,

        getonboardingGrid: 1,
        postholdStatusData: 2,
        postonboardingDate: 3,
        postjoiningDate: 4,
        postmarkNotJoining: 5,
        getdocumentDetailsGrid: 6,
        postapproveDocStatus: 7,
        postrejectionData: 8,
        getEmployeeDetailsGrid: 9,
        postapplyOnboarding: 10,
        deleteInterview: 16,

        getJobs: 1,
        getFormDropDownValues: 2,
        postJobs: 3,
        getJobInfo: 4,
        updateJob: 5,
        getJobBoards: 6,
        getHiringTeam: 7,
        getHiringProcess: 8,
        getRoundAssessment: 9,
        getAssessmentTypes: 10,
        addHiringMember: 11,
        addAssessmentType: 12,
        addInterviewRound: 13,
        getPanelMemberJob: 15,
        getSearchData: 11,
        getFilterData: 12,
        getSortData: 13,
        updateCandidate: 7,
        postJobsActions: 18,
        deleteScreening:26,
 
        getTasks: 1,
        postFresherTasks: 2,
        postExpTasks: 3,
        updateFresherTasks: 4,
        updateExpTasks: 5,
        insertRoundAssessment: 17,

        getFresherDocuments: 1,
        getExpDocuments: 2,
        postFresherDocumentDetails: 3,
        postExpDocumentDetails: 4,
        getHiringTeamLogin: 2,

        getPreliminary: 17,
        getSummary: 18,

        getHiringMembers: 14,
        getOfferLetterTemplate: 6,
        directory: 35,
        postexpFeedback: 9,
        getInterviewRoundName: 12,
        postOnboarding: 3,
        updatejobs: 22,
        postEntity: 14,
        getEntityId: 15,
        postHireStage: 16,
        getExpSearchData: 19,
        getFresherSearchData: 20,
        getCandidateCount: 23,
        getPrelimFeedback: 10,
        getSingleJob: 24,
        republish: 25,
        getFresherFilter: 23,
        getExpFilter: 24,
        getExpSort: 26,
        getvalue: 27,
        overallcolor: 28,
        getFresherRound: 29,
        getFresherInterview: 30,
        updateFeedBackData: 13,
        sendMailCandidate: 15,
        insertBulkInterviewData: 14,
        getBatchDetails: 16,
        updatePrelimAns: 11,
    },
};
export default recruitmentAPIIndex;

// // the endpoint to get the requested data
// export const NODE_URL = 'https://ca7c32vkq5.execute-api.us-east-2.amazonaws.com/HIVE-STAGE/todo';
// // export const NODE_URL = 'http://localhost:4000/todo';

//methods to be called to get the data from db
export const todo_apiIndex = {
    module: {
        todo: 1,
        teamMembers: 2,
        concerns: 4,
        faq: 3,
        getPolicy: 5,
        inserUpdatetPolicy: 6,
    },
    methodname: {
        getMyTodo: 1,
        searchMyTodo: 2,
        sortMyTodo: 3,
        filterMyTodo: 4,
        deleteMyTodo: 8,
        postMyTodo: 6,
        getTodoFilterData: 5,
        updateMyTodo: 7,
        getTeamMembers: 9,
        getTeamMemberTodo: 10,
        searchTeamMember: 11,
        sortTeamMember: 12,
        getFilterData: 13,
        filterTeamMembers: 14,
        getConcerns: 21,
        postConcern: 22,
        updateConcern: 23,
        deleteConcern: 24,
        viewConcern: 26,
        getConcernByID: 27,
        getTeamConcerns: 25,
        getDepartment: 28,
        getPeople: 29,
        updateViewConcern: 30,
        getFAQ: 15,
        getFAQByID: 19,
        postFAQ: 16,
        updateFAQ: 17,
        deleteFAQ: 18,
        getCategories: 20,
        insertNotification: 31,
        PostHireTimeline: 4,
        getFormDropDowns: 39,
        getActivePolices: 41,
        getInActivePolices: 42,
        getAllpolices: 43,

        getAuditHistory: 31,
        getAckUsers: 32,
        getUnAckUsers: 33,
        ribbonAlert: 34,
        getPolicyDirectoryDetails: 35,
        getIndividualPolicyDirectoryDetails: 36,
        getUserRibbon: 38,
        insertPolicy: 44,
        updatePolicy: 45,
        approvalPolicy: 46,
        insertSignedPolicy: 47,
        repopulatePolicy: 37,
    },
};

export const decoder = (data) => JSON.parse(decode(decode(data).substring(10, decode(data).length)));

function error2(str) {
    return str.slice(3, -3);
  };